import { BlankLayout } from '@/components/layouts';

export default {
  path: '/help',
  name: 'Help',
  component: BlankLayout,
  meta: { module: '帮助与反馈' },
  children: [
    {
      path: '/help/question/:id',
      name: 'Help.Question.Details',
      component: () => import(/* webpackChunkName: 'help-question-details' */ '../../views/help/question/Details.vue'),
      meta: { title: '帮助与反馈_常见问题', hideBanner: true },
    },
    {
      path: '/help/main',
      name: 'Help.Feedback.Main',
      component: () => import(/* webpackChunkName: 'help-feedback-main' */ '../../views/help/feedback/index.vue'),
      meta: { title: '意见反馈', hideBanner: true, requiredLogin: true },
    },
    {
      path: '/help/feedback/:id',
      name: 'Help.Feedback.Details',
      component: () => import(/* webpackChunkName: 'help-feedback-details' */ '../../views/help/feedback/Details.vue'),
      meta: { title: '意见反馈_反馈详情', hideBanner: true, requiredLogin: true },
    },
    {
      path: '/help/my-feedback/:id',
      name: 'Help.My.Feedback.Details',
      component: () => import(/* webpackChunkName: 'help-feedback-new-details' */ '../../views/help/feedback/NewDetails.vue'),
      meta: {
        title: '意见反馈_反馈详情', alias: '来源_意见反馈', hideBanner: true, requiredLogin: true,
      },
    },
    {
      path: '/help/visitor',
      name: 'Help.Feedback.Visitor',
      component: () => import(/* webpackChunkName: 'help-feedback-visitor' */ '../../views/help/feedback/VisitorFeedBack.vue'),
      meta: { title: '意见反馈', alias: '访客_意见反馈', hideBanner: true },
    },
  ],
};
